var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"line",attrs:{"data-lang":_vm.language}},[_vm._l((_vm.tokens),function(token,tokenIndex){return _c('span',{key:tokenIndex,class:token.class},[_vm._v(_vm._s(token.value))])}),_vm._v(" "),_c('br')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }